import { useState, useEffect } from "react";
import { LoadingScreen, NoAccessScreen } from "../../components";
import { AppFeature } from "../../Constant";
import { usePagePermission } from "../../Hook";
import {
  CustomReportQuery_api,
  SaveReportTemplate_api,
  FetchReportTemplates_api,
  DeleteReportTemplate_api,
  CallAiAgent_api,
} from "../../Api";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import {
  Search,
  Download,
  Plus,
  Trash2,
  Filter,
  Settings2,
  ChevronDown,
  LayoutGrid,
  ArrowUpDown,
  ArrowLeftRight,
  ListOrdered,
  Bot,
  Send,
  Sparkles,
  Terminal,
} from "lucide-react";
import { Spin, Select, Tag, Empty, DatePicker, InputNumber, Modal, message, Switch, Drawer } from "antd";
import { useAuthChecker } from "../../Context";
import TextArea from "antd/es/input/TextArea";
import { downloadExcel } from "../../lib/excelGenerator";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { TABLE_NODES_CONFIG, RELATION_MAP } from "./NodeReports";
import { NodeReportQuery_api } from "../../Api/Reports/node_report_query";

const { Option } = Select;
const { RangePicker } = DatePicker;

const MODULE_CONFIG: any = {
  payments: {
    label: "Payments",
    fields: [
      { value: "id", label: "Payment ID", type: "number" },
      { value: "slip_id", label: "Slip ID", type: "text" },
      { value: "slip_date", label: "Slip Date", type: "date" },
      { value: "amount", label: "Amount", type: "number" },
      { value: "customer_id", label: "Customer ID", type: "number" },
      { value: "payment_type_id", label: "Payment Type ID", type: "number" },
      { value: "added_user", label: "Added User ID", type: "number" },
      { value: "added_date", label: "Added Date", type: "datetime" },
      { value: "dataobj", label: "Data Object", type: "text" },
      { value: "updated_user", label: "Updated User ID", type: "number" },
      { value: "updated_date_time", label: "Updated Date", type: "datetime" },
      { value: "imageName", label: "Image Name", type: "text" },
      { value: "is_credited", label: "Is Credited", type: "number" },
    ],
    relations: {
      customers: {
        label: "Link Customers",
        fields: [
          { value: "customer_name", label: "Customer Name", type: "text", table: "Customer" },
          { value: "customer_mobile", label: "Customer Mobile", type: "text", table: "Customer" },
        ]
      },
      payment_types: {
        label: "Link Payment Types",
        fields: [
          { value: "payment_type", label: "Payment Type", type: "text", table: "Payment Type" },
        ]
      },
      added_users: {
        label: "Link User (Added By)",
        fields: [
          { value: "added_by", label: "Added By", type: "text", table: "User" },
        ]
      },
      inquiries: {
        label: "Link Inquiries",
        fields: [
          { value: "inquiry_number", label: "Inquiry Number", type: "text", table: "Inquiry" },
          { value: "inquiry_status", label: "Inquiry Status", type: "text", table: "Inquiry" },
          { value: "inquiry_total", label: "Inquiry Total", type: "number", table: "Inquiry" },
        ]
      }
    }
  },
  vehicles: {
    label: "Vehicles",
    fields: [
      { value: "id", label: "Vehicle ID", type: "number" },
      { value: "engine_number", label: "Engine Number", type: "text" },
      { value: "chassis_number", label: "Chassis Number", type: "text" },
      { value: "status", label: "Status", type: "text" },
      { value: "v_color", label: "Color ID", type: "number" },
      { value: "vehicle_type_has_vehicle_modal_id", label: "Type Model ID", type: "number" },
      { value: "dealer_id", label: "Dealer ID", type: "number" },
      { value: "current_dealer_id", label: "Current Dealer ID", type: "number" },
      { value: "return_date", label: "Return Date", type: "datetime" },
      { value: "reaturn_reson", label: "Return Reason", type: "text" },
      { value: "added_date", label: "Added Date", type: "datetime" },
      { value: "sold_date", label: "Sold Date", type: "datetime" },
      { value: "sold_remarks", label: "Sold Remarks", type: "text" },
      { value: "gate_pass_image", label: "Gate Pass Image", type: "text" },
      { value: "instock_date", label: "In Stock Date", type: "datetime" },
    ],
    relations: {
      models: {
        label: "Link Vehicle Models & Types",
        fields: [
          { value: "vehicle_type", label: "Vehicle Type", type: "text", table: "Vehicle Type" },
          { value: "vehicle_modal", label: "Vehicle Model", type: "text", table: "Vehicle Model" },
        ]
      },
      original_dealers: {
        label: "Link Original Dealer",
        fields: [
          { value: "original_dealer", label: "Original Dealer", type: "text", table: "Original Dealer" },
        ]
      },
      current_dealers: {
        label: "Link Current Dealer",
        fields: [
          { value: "current_dealer", label: "Current Dealer", type: "text", table: "Current Dealer" },
        ]
      },
      colors: {
        label: "Link Colors",
        fields: [
          { value: "color", label: "Color", type: "text", table: "Color" },
        ]
      }
    }
  },
  customers: {
    label: "Customers",
    fields: [
      { value: "id", label: "Customer ID", type: "number" },
      { value: "name", label: "Name", type: "text" },
      { value: "mobile", label: "Mobile", type: "text" },
    ],
    relations: {
      inquiries: {
        label: "Link Inquiries",
        fields: [
          { value: "inquiry_number", label: "Inquiry Number", type: "text", table: "Inquiry" },
          { value: "inquiry_status", label: "Inquiry Status", type: "text", table: "Inquiry" },
          { value: "inquiry_total", label: "Inquiry Total", type: "number", table: "Inquiry" },
        ]
      }
    }
  },
  inquiries: {
    label: "Inquiries",
    fields: [
      { value: "id", label: "Inquiry ID", type: "number" },
      { value: "inquiry_number", label: "Inquiry Number", type: "text" },
      { value: "total_amount", label: "Amount", type: "number" },
      { value: "amount", label: "Raw Amount", type: "number" },
      { value: "discount", label: "Discount", type: "number" },
      { value: "status", label: "Status", type: "text" },
      { value: "isPaidCompany", label: "Is Paid Company", type: "number" },
      { value: "company_paid_amount", label: "Company Paid Amount", type: "number" },
      { value: "vehicle_type_id", label: "Vehicle Type ID", type: "number" },
      { value: "vehicle_modal_id", label: "Vehicle Model ID", type: "number" },
      { value: "vehicle_id", label: "Vehicle ID", type: "number" },
      { value: "priceList", label: "Price List", type: "text" },
      { value: "dealer_id", label: "Dealer ID", type: "number" },
      { value: "sales_person_id", label: "Sales Person ID", type: "number" },
      { value: "isOfferAdded", label: "Is Offer Added", type: "number" },
      { value: "downpayment", label: "Downpayment", type: "number" },
      { value: "loanamount", label: "Loan Amount", type: "number" },
    ],
    relations: {
      customers: {
        label: "Link Customers",
        fields: [
          { value: "customer_name", label: "Customer Name", type: "text", table: "Customer" },
          { value: "customer_mobile", label: "Customer Mobile", type: "text", table: "Customer" },
        ]
      },
      dealers: {
        label: "Link Dealers",
        fields: [
          { value: "dealer_name", label: "Dealer Name", type: "text", table: "Dealer" },
        ]
      },
      sales_persons: {
        label: "Link Sales Persons",
        fields: [
          { value: "sales_person", label: "Sales Person", type: "text", table: "Sales Person" },
        ]
      },
      types: {
        label: "Link Vehicle Type",
        fields: [
          { value: "vehicle_type", label: "Vehicle Type", type: "text", table: "Vehicle Type" },
        ]
      },
      models: {
        label: "Link Vehicle Model",
        fields: [
          { value: "vehicle_modal", label: "Vehicle Model", type: "text", table: "Vehicle Model" },
        ]
      },
      vehicles: {
        label: "Link Assigned Vehicle",
        fields: [
          { value: "engine_number", label: "Engine Number", type: "text", table: "Vehicle" },
          { value: "chassis_number", label: "Chassis Number", type: "text", table: "Vehicle" },
        ]
      }
    }
  },
  remittances: {
    label: "Remittances",
    fields: [
      { value: "id", label: "Remittance ID", type: "number" },
      { value: "transfer_id", label: "Transfer ID", type: "text" },
      { value: "slip_date", label: "Slip Date", type: "date" },
      { value: "amount", label: "Amount", type: "number" },
      { value: "bank_account_id", label: "Bank Account ID", type: "number" },
      { value: "bank_accounts_id", label: "Bank Accounts ID Reference", type: "number" },
      { value: "user_id", label: "User ID", type: "number" },
      { value: "added_date_time", label: "Added Date", type: "datetime" },
      { value: "dataObj", label: "Data Object", type: "text" },
      { value: "updated_user", label: "Updated User ID", type: "number" },
      { value: "updated_date_time", label: "Updated Date", type: "datetime" },
      { value: "imageName", label: "Image Name", type: "text" },
    ],
    relations: {
      added_users: {
        label: "Link User (Added By)",
        fields: [
          { value: "added_by", label: "Added By", type: "text", table: "User" },
        ]
      },
      bank_accounts: {
        label: "Link Bank Accounts",
        fields: [
          { value: "bank_name", label: "Bank Name", type: "text", table: "Bank Account" },
          { value: "account_number", label: "Account Number", type: "text", table: "Bank Account" },
        ]
      }
    }
  },
  dealers: {
    label: "Dealers",
    fields: [
      { value: "id", label: "Dealer ID", type: "number" },
      { value: "name", label: "Name", type: "text" },
      { value: "contact_number", label: "Contact Number", type: "text" },
      { value: "email", label: "Email", type: "text" },
      { value: "city_id", label: "City ID", type: "number" },
      { value: "is_active", label: "Is Active", type: "number" },
      { value: "status", label: "Status", type: "text" },
    ],
    relations: {
      cities: {
        label: "Link Cities",
        fields: [
          { value: "city", label: "City", type: "text", table: "City" },
        ]
      }
    }
  },
  sales_persons: {
    label: "Sales Persons",
    fields: [
      { value: "id", label: "Sales Person ID", type: "number" },
      { value: "name", label: "Name", type: "text" },
      { value: "contact_number", label: "Contact Number", type: "text" },
      { value: "email", label: "Email", type: "text" },
      { value: "status", label: "Status", type: "text" },
      { value: "dealer_id", label: "Dealer ID", type: "number" },
    ],
    relations: {
      dealers: {
        label: "Link Dealers",
        fields: [
          { value: "dealer", label: "Dealer", type: "text", table: "Dealer" },
        ]
      }
    }
  },
  bank_transactions: {
    label: "Bank Transactions",
    fields: [
      { value: "id", label: "Transaction ID", type: "number" },
      { value: "date", label: "Transaction Date", type: "datetime" },
      { value: "amount", label: "Amount", type: "number" },
      { value: "from_bank_id", label: "Source Bank ID", type: "number" },
      { value: "to_bank_id", label: "Destination Bank ID", type: "number" },
      { value: "payload", label: "Payload JSON", type: "text" },
      { value: "addedDate", label: "Added Date", type: "datetime" },
      { value: "user_id", label: "Added By User ID", type: "number" },
      { value: "transactionfee", label: "Transaction Fee Raw", type: "number" },
      { value: "transaction_fee", label: "Transaction Fee", type: "number" },
      { value: "transaction_type", label: "Transaction Type", type: "text" },
      { value: "other_details", label: "Other Details", type: "text" },
    ],
    relations: {
      from_banks: {
        label: "Link Source Bank",
        fields: [
          { value: "from_bank", label: "From Bank", type: "text", table: "From Bank" },
        ]
      },
      to_banks: {
        label: "Link Destination Bank",
        fields: [
          { value: "to_bank", label: "To Bank", type: "text", table: "To Bank" },
        ]
      },
      added_users: {
        label: "Link User (Added By)",
        fields: [
          { value: "added_by", label: "Added By", type: "text", table: "User" },
        ]
      }
    }
  },
  stock_transfers: {
    label: "Stock Transfers",
    fields: [
      { value: "id", label: "Transfer ID", type: "number" },
      { value: "vehicle_id", label: "Vehicle ID", type: "number" },
      { value: "from_stock_type", label: "Source Stock Type", type: "text" },
      { value: "from_dealer_id", label: "Source Dealer ID", type: "number" },
      { value: "to_stock_type", label: "Destination Stock Type", type: "text" },
      { value: "to_dealer_id", label: "Destination Dealer ID", type: "number" },
      { value: "transfer_date", label: "Transfer Date", type: "datetime" },
      { value: "remarks", label: "Remarks", type: "text" },
    ],
    relations: {
      vehicles: {
        label: "Link Vehicles",
        fields: [
          { value: "engine_number", label: "Engine Number", type: "text", table: "Vehicle" },
          { value: "chassis_number", label: "Chassis Number", type: "text", table: "Vehicle" },
        ]
      },
      from_dealers: {
        label: "Link Source Dealer",
        fields: [
          { value: "from_dealer", label: "From Dealer", type: "text", table: "From Dealer" },
        ]
      },
      to_dealers: {
        label: "Link Destination Dealer",
        fields: [
          { value: "to_dealer", label: "To Dealer", type: "text", table: "To Dealer" },
        ]
      }
    }
  },
  grn: {
    label: "Goods Received (GRN)",
    fields: [
      { value: "id", label: "GRN ID", type: "number" },
      { value: "invoice_id", label: "Invoice ID", type: "text" },
      { value: "invoice_date", label: "Invoice Date", type: "date" },
      { value: "total", label: "Total Amount Raw", type: "number" },
      { value: "total_amount", label: "Total Amount", type: "number" },
      { value: "added_date", label: "Added Date", type: "datetime" },
    ],
    relations: {
      items: {
        label: "Link GRN Products & Quantities",
        fields: [
          { value: "product_name", label: "Product Name", type: "text", table: "Product" },
          { value: "quantity", label: "Quantity", type: "number", table: "Product" },
          { value: "cost", label: "Cost Price", type: "number", table: "Product" },
        ]
      }
    }
  },
  credits: {
    label: "Customer Credits",
    fields: [
      { value: "id", label: "Credit ID", type: "number" },
      { value: "amount", label: "Credit Amount", type: "number" },
      { value: "added_date", label: "Added Date", type: "date" },
      { value: "inquiry_number", label: "Inquiry ID Reference", type: "number" },
      { value: "status", label: "Status", type: "text" },
      { value: "paid_date", label: "Paid Date", type: "date" },
      { value: "payment_details_id", label: "Payment Details ID", type: "number" },
    ],
    relations: {
      inquiries: {
        label: "Link Inquiries",
        fields: [
          { value: "inquiry_number", label: "Inquiry Number", type: "text", table: "Inquiry" },
        ]
      },
      customers: {
        label: "Link Customers",
        fields: [
          { value: "customer_name", label: "Customer Name", type: "text", table: "Customer" },
        ]
      }
    }
  },
  products: {
    label: "Inventory (Products)",
    fields: [
      { value: "id", label: "Stock ID", type: "number" },
      { value: "product_id", label: "Product Catalog ID", type: "number" },
      { value: "qty", label: "Quantity Raw", type: "number" },
      { value: "quantity", label: "Quantity In Stock", type: "number" },
      { value: "cost", label: "Cost Price", type: "number" },
      { value: "status", label: "Status", type: "text" },
    ],
    relations: {
      products: {
        label: "Link Products Master",
        fields: [
          { value: "product_name", label: "Product Name", type: "text", table: "Product" },
        ]
      }
    }
  },
  product_releases: {
    label: "Inventory Releases",
    fields: [
      { value: "id", label: "Release ID", type: "number" },
      { value: "inquery_number", label: "Inquiry ID Reference", type: "number" },
      { value: "product_has_stock", label: "Stock ID Reference", type: "number" },
      { value: "product_name", label: "Product Name Override", type: "text" },
      { value: "qty", label: "Quantity Raw", type: "number" },
      { value: "quantity", label: "Quantity Released", type: "number" },
      { value: "date", label: "Release Date", type: "date" },
    ],
    relations: {
      products: {
        label: "Link Released Products",
        fields: [
          { value: "product_name", label: "Product Name", type: "text", table: "Product" },
        ]
      },
      inquiries: {
        label: "Link Inquiries",
        fields: [
          { value: "inquiry_number", label: "Inquiry Number", type: "text", table: "Inquiry" },
        ]
      }
    }
  },
};

const OPERATORS = [
  { value: "=", label: "Equals" },
  { value: "contains", label: "Contains" },
  { value: "starts_with", label: "Starts With" },
  { value: "ends_with", label: "Ends With" },
  { value: ">", label: "Greater Than" },
  { value: "<", label: "Less Than" },
  { value: "!=", label: "Not Equals" },
  { value: "between", label: "Between" },
];

const AGG_FUNCTIONS = [
  { value: "COUNT", label: "COUNT (Record Count)" },
  { value: "SUM", label: "SUM (Total)" },
  { value: "AVG", label: "AVG (Average)" },
  { value: "MIN", label: "MIN (Minimum)" },
  { value: "MAX", label: "MAX (Maximum)" },
];

export const CustomReports = () => {
  const { isLoading: permissionLoading, hasPermission } = usePagePermission(
    AppFeature.CUSTOM_REPORTS,
    ["admin", "manager"],
  );

  const { user } = useAuthChecker();
  const navigate = useNavigate();

  // AI Agent States
  const [isAiDrawerOpen, setIsAiDrawerOpen] = useState(false);
  const [aiPrompt, setAiPrompt] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiExplanation, setAiExplanation] = useState("");
  const [aiSql, setAiSql] = useState("");

  const handleAiSearch = async (text: string) => {
    setAiLoading(true);
    setAiExplanation("");
    setAiSql("");
    try {
      const res = await CallAiAgent_api(
        text + "\n[Context: SQL Reporting Explorer. You MUST generate 'sql' mode response with safe read-only SELECT statement and explain it. Do not return workspace visualConfig.]"
      );
      if (res.success) {
        setAiExplanation(res.explanation || "");
        if (res.mode === "sql" && res.sql) {
          setAiSql(res.sql);
          if (res.data) {
            setIsAdvancedMode(true);
            setReportData(res.data);
            if (res.data.length > 0) {
              const keys = Object.keys(res.data[0]);
              setAdvSelectedColumns(keys);
              setColumns(keys);
            } else {
              setAdvSelectedColumns([]);
              setColumns([]);
            }
            setIsGrouping(false);
            message.success(`AI Query executed successfully! Retrieved ${res.rowCount} rows.`);
          }
        } else {
          message.warning("AI generated a visual workspace config instead of a SQL report. Please switch to the Visual Node Builder to generate workspaces.");
        }
      } else {
        message.error(res.msg || "Failed to generate AI report");
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to connect to AI agent");
    } finally {
      setAiLoading(false);
    }
  };

  const [module, setModule] = useState<string>("payments");
  const [selectedRelations, setSelectedRelations] = useState<string[]>([]);
  const [filters, setFilters] = useState<any[]>([]);
  const [reportData, setReportData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState<string[]>([]);
  const [orderBy, setOrderBy] = useState<string>("");
  const [orderDir, setOrderDir] = useState<string>("DESC");
  const [limit, setLimit] = useState<number>(1000);

  // Grouping & Aggregations States
  const [isGrouping, setIsGrouping] = useState<boolean>(false);
  const [groupByField, setGroupByField] = useState<string>("");
  const [aggField, setAggField] = useState<string>("");
  const [aggFunc, setAggFunc] = useState<string>("COUNT");

  const [templates, setTemplates] = useState<any[]>([]);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [templateName, setTemplateName] = useState("");

  const [isAdvancedMode, setIsAdvancedMode] = useState<boolean>(false);
  const [advBaseTable, setAdvBaseTable] = useState<string>("payment_details");
  const [advJoinedTables, setAdvJoinedTables] = useState<string[]>([]);
  const [advSelectedColumns, setAdvSelectedColumns] = useState<string[]>([]);

  const getAdvancedFilterableFields = () => {
    const fields: { value: string, label: string, type: 'text' | 'number' | 'date' | 'datetime' }[] = [];
    const tables = [advBaseTable, ...advJoinedTables];
    tables.forEach(table => {
      const config = TABLE_NODES_CONFIG[table];
      if (config) {
        config.fields.forEach(f => {
          fields.push({
            value: `${table}.${f.name}`,
            label: `[${config.label}] ${f.name}`,
            type: f.type
          });
        });
      }
    });
    return fields;
  };

  const getActiveConnections = (activeTables: string[]) => {
    const activeConns: any[] = [];
    RELATION_MAP.forEach(rel => {
      if (activeTables.includes(rel.fromTable) && activeTables.includes(rel.toTable)) {
        const exists = activeConns.some(
          c =>
            (c.fromTable === rel.fromTable && c.fromField === rel.fromField && c.toTable === rel.toTable && c.toField === rel.toField) ||
            (c.fromTable === rel.toTable && c.fromField === rel.toField && c.toTable === rel.fromTable && c.toField === rel.fromField)
        );
        if (!exists) {
          activeConns.push({
            fromTable: rel.fromTable,
            fromField: rel.fromField,
            toTable: rel.toTable,
            toField: rel.toField
          });
        }
      }
    });
    return activeConns;
  };

  const getVisibleColumns = () => {
    return isAdvancedMode ? advSelectedColumns : columns;
  };

  const setVisibleColumns = (cols: string[]) => {
    if (isAdvancedMode) {
      setAdvSelectedColumns(cols);
    } else {
      setColumns(cols);
    }
  };

  const loadTemplates = async () => {
    const res = await FetchReportTemplates_api();
    if (res.success) {
      setTemplates(res.data || []);
    }
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const getActiveFields = (mod: string, activeRelations: string[]) => {
    if (!MODULE_CONFIG[mod]) return [];
    let fields = [...MODULE_CONFIG[mod].fields];
    const relations = MODULE_CONFIG[mod].relations || {};
    activeRelations.forEach((relKey) => {
      if (relations[relKey]) {
        fields = [...fields, ...relations[relKey].fields];
      }
    });
    return fields;
  };

  // Initialize columns and sorting on mount or manually when changing module
  useEffect(() => {
    setSelectedRelations([]);
    setFilters([]);
    setReportData([]);
    setIsGrouping(false);
    
    if (MODULE_CONFIG[module]) {
      setColumns(MODULE_CONFIG[module].fields.map((f: any) => f.value));
      setOrderBy(MODULE_CONFIG[module].fields[0].value);
      setGroupByField(MODULE_CONFIG[module].fields[0].value);
      setAggField(MODULE_CONFIG[module].fields[0].value);
    }
  }, [module]);

  const addFilter = () => {
    const activeFields = isAdvancedMode ? getAdvancedFilterableFields() : getActiveFields(module, selectedRelations);
    if (activeFields.length === 0) return;
    const defaultField = activeFields[0];
    setFilters([
      ...filters,
      {
        field: defaultField.value,
        operator:
          defaultField.type === "date" || defaultField.type === "datetime"
            ? "between"
            : "contains",
        value: "",
      },
    ]);
  };

  const removeFilter = (index: number) => {
    const newFilters = [...filters];
    newFilters.splice(index, 1);
    setFilters(newFilters);
  };

  const updateFilter = (index: number, key: string, value: any) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const runReport = async () => {
    setLoading(true);

    const activeFilters = filters.filter((f) => {
      if (f.value === "" || f.value === null || f.value === undefined) {
        return false;
      }
      if (f.operator === "between" && Array.isArray(f.value)) {
        return f.value[0] !== "" || f.value[1] !== "";
      }
      return true;
    });

    if (isAdvancedMode) {
      const activeFields = getAdvancedFilterableFields();
      const processedFilters = activeFilters.map((f) => {
        const fieldConfig = activeFields.find((field: any) => field.value === f.field);
        if (f.operator === "between" && Array.isArray(f.value)) {
          const isDateTime = fieldConfig?.type === "datetime";
          const isDate = fieldConfig?.type === "date";

          if (isDateTime || isDate) {
            const formatStr = isDateTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
            let startVal = f.value[0] ? dayjs(f.value[0]).startOf("day").format(formatStr) : "";
            let endVal = f.value[1] ? dayjs(f.value[1]).endOf("day").format(formatStr) : "";
            return {
              ...f,
              value: [startVal, endVal],
            };
          }
        }
        return f;
      });

      const nodes = [advBaseTable, ...advJoinedTables];
      const activeConns = getActiveConnections(nodes);

      const response = await NodeReportQuery_api(
        nodes,
        activeConns,
        advSelectedColumns,
        processedFilters.map(f => ({ field: f.field, operator: f.operator, value: f.value })),
        limit,
        isGrouping ? groupByField : "",
        isGrouping && aggField ? { field: aggField, function: aggFunc } : null
      );

      if (response.success) {
        setReportData(response.data || []);
      } else {
        message.error(response.msg || "Failed to fetch advanced report");
      }
      setLoading(false);
      return;
    }

    const activeFields = getActiveFields(module, selectedRelations);
    const processedFilters = activeFilters.map((f) => {
      const fieldConfig = activeFields.find((field: any) => field.value === f.field);
      if (f.operator === "between" && Array.isArray(f.value)) {
        const isDateTime = fieldConfig?.type === "datetime";
        const isDate = fieldConfig?.type === "date";

        if (isDateTime || isDate) {
          const formatStr = isDateTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
          let startVal = f.value[0] ? dayjs(f.value[0]).startOf("day").format(formatStr) : "";
          let endVal = f.value[1] ? dayjs(f.value[1]).endOf("day").format(formatStr) : "";
          return {
            ...f,
            value: [startVal, endVal],
          };
        }
      }
      return f;
    });

    const response = await CustomReportQuery_api(
      module,
      selectedRelations,
      processedFilters,
      isGrouping ? [] : columns,
      isGrouping ? orderBy : orderBy,
      orderDir,
      limit,
      isGrouping ? groupByField : "",
      isGrouping ? { field: aggField, function: aggFunc } : null,
    );
    
    if (response.success) {
      setReportData(response.data || []);
    } else {
      message.error(response.msg || "Failed to fetch report");
    }
    setLoading(false);
  };

  const handleDownloadExcel = () => {
    if (reportData.length === 0) return;
    
    let headers: string[];
    let data: any[][];

    if (isAdvancedMode) {
      if (isGrouping) {
        const aggLabel = aggField ? `${aggFunc}(${aggField})` : "Count";
        headers = [groupByField, aggLabel];
        data = reportData.map(row => [
          row[groupByField] ?? row[groupByField.replace('.', '$')] ?? "--",
          row.aggregate_value ?? 0
        ]);
      } else {
        headers = advSelectedColumns;
        data = reportData.map(row => 
          advSelectedColumns.map(col => row[col] ?? row[col.replace('.', '$')] ?? "")
        );
      }
    } else {
      const currentModuleFields = getActiveFields(module, selectedRelations);
      if (isGrouping) {
        const groupLabel = currentModuleFields.find((f: any) => f.value === groupByField)?.label || groupByField;
        const aggLabel = `${aggFunc} of ${currentModuleFields.find((f: any) => f.value === aggField)?.label || 'Records'}`;
        headers = [groupLabel, aggLabel];
        data = reportData.map((row) => [
          row[groupByField] || "--",
          isCurrencyCell("aggregate_value") 
            ? formatCurrency(row.aggregate_value)
            : row.aggregate_value || 0
        ]);
      } else {
        headers = columns.map(
          (col) => currentModuleFields.find((f: any) => f.value === col)?.label || col
        );
        data = reportData.map((row) =>
          columns.map((col) => {
            if (isCurrencyField(col)) {
              return formatCurrency(row[col]);
            }
            return row[col] || "";
          })
        );
      }
    }

    downloadExcel(
      `Custom Report`,
      headers,
      data,
      `Custom_Report_${isAdvancedMode ? 'advanced' : module}_${new Date().getTime()}`,
    );
  };

  const handleSaveTemplate = async () => {
    if (!templateName.trim()) {
      message.error("Please enter a name for the template");
      return;
    }
    
    const configuration = {
      isAdvancedMode,
      advBaseTable,
      advJoinedTables,
      advSelectedColumns,
      columns,
      filters: filters.map((f) => {
        const fieldConfig = (isAdvancedMode ? getAdvancedFilterableFields() : getActiveFields(module, selectedRelations))
          .find((field: any) => field.value === f.field);
        
        if (f.operator === "between" && Array.isArray(f.value)) {
          const isDateOrTime = fieldConfig?.type === "date" || fieldConfig?.type === "datetime";
          if (isDateOrTime) {
            return {
              ...f,
              value: [
                f.value[0] ? dayjs(f.value[0]).toISOString() : "",
                f.value[1] ? dayjs(f.value[1]).toISOString() : "",
              ],
            };
          }
        }
        return f;
      }),
      orderBy,
      orderDir,
      limit,
      isGrouping,
      groupByField,
      aggField,
      aggFunc,
      selectedRelations,
    };

    const res = await SaveReportTemplate_api(
      templateName,
      isAdvancedMode ? "advanced_custom_report" : module,
      configuration,
      user?.userId || null,
    );

    if (res.success) {
      message.success(res.msg);
      setIsSaveModalOpen(false);
      setTemplateName("");
      loadTemplates();
    } else {
      message.error(res.msg || "Failed to save template");
    }
  };

  const handleLoadTemplate = (template: any) => {
    let config: any = {};
    try {
      config =
        typeof template.configuration === "string"
          ? JSON.parse(template.configuration)
          : template.configuration;
    } catch (e) {
      console.error(e);
    }

    const isAdv = template.module === "advanced_custom_report" || template.module === "node_workspace" || !!config.isAdvancedMode;
    setIsAdvancedMode(isAdv);

    if (isAdv) {
      let baseTable = "payment_details";
      let joinedTables: string[] = [];
      if (config.nodes && Array.isArray(config.nodes) && config.nodes.length > 0) {
        baseTable = config.nodes[0];
        joinedTables = config.nodes.slice(1);
      } else {
        if (config.advBaseTable) baseTable = config.advBaseTable;
        if (config.advJoinedTables) joinedTables = config.advJoinedTables;
      }

      setAdvBaseTable(baseTable);
      setAdvJoinedTables(joinedTables);

      const cols = config.columns ?? config.advSelectedColumns ?? [];
      setAdvSelectedColumns(cols);
      
      if (config.filters) {
        const restoredFilters = config.filters.map((f: any) => {
          if (f.operator === "between" && Array.isArray(f.value)) {
            return {
              ...f,
              value: [
                f.value[0] ? dayjs(f.value[0]) : null,
                f.value[1] ? dayjs(f.value[1]) : null,
              ],
            };
          }
          return f;
        });
        setFilters(restoredFilters);
      } else {
        setFilters([]);
      }
    } else {
      setModule(template.module);
      if (config.selectedRelations) {
        setSelectedRelations(config.selectedRelations);
      } else {
        setSelectedRelations([]);
      }
      if (config.columns) setColumns(config.columns);
      if (config.filters) {
        const activeFields = getActiveFields(template.module, config.selectedRelations || []);
        const restoredFilters = config.filters.map((f: any) => {
          const fieldConfig = activeFields.find((field: any) => field.value === f.field);
          if (f.operator === "between" && Array.isArray(f.value)) {
            const isDateOrTime = fieldConfig?.type === "date" || fieldConfig?.type === "datetime";
            if (isDateOrTime) {
              return {
                ...f,
                value: [
                  f.value[0] ? dayjs(f.value[0]) : null,
                  f.value[1] ? dayjs(f.value[1]) : null,
                ],
              };
            }
          }
          return f;
        });
        setFilters(restoredFilters);
      } else {
        setFilters([]);
      }
    }

    if (config.orderBy) setOrderBy(config.orderBy);
    if (config.orderDir) setOrderDir(config.orderDir);
    if (config.limit) setLimit(config.limit);

    if (config.isGrouping !== undefined) setIsGrouping(config.isGrouping);
    if (config.groupByField) setGroupByField(config.groupByField);
    if (config.aggField) setAggField(config.aggField);
    if (config.aggFunc) setAggFunc(config.aggFunc);

    message.success(`Loaded template: ${template.name}`);
  };

  const handleDeleteTemplate = async (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    const res = await DeleteReportTemplate_api(id);
    if (res.success) {
      message.success(res.msg);
      loadTemplates();
    } else {
      message.error(res.msg || "Failed to delete template");
    }
  };

  const isCurrencyField = (field: string) => {
    const cleanField = field.includes(".") ? field.split(".")[1] : field;
    return ["amount", "total_amount", "transaction_fee", "cost"].includes(cleanField);
  };

  const isCurrencyCell = (col: string) => {
    return (
      isCurrencyField(col) ||
      (col === "aggregate_value" && isGrouping && isCurrencyField(aggField) && aggFunc !== "COUNT")
    );
  };

  const formatCurrency = (val: any) => {
    return new Intl.NumberFormat("en-LK", {
      style: "currency",
      currency: "LKR",
      minimumFractionDigits: 2,
    }).format(parseFloat(val || 0));
  };

  if (permissionLoading) {
    return <LoadingScreen messageQueue={"Loading..."} />;
  }

  if (!hasPermission) {
    return <NoAccessScreen />;
  }

  const currentModuleFields = getActiveFields(module, selectedRelations);

  return (
    <div className="w-full h-screen bg-gray-50 p-6 overflow-hidden flex flex-col gap-4">
      {/* Header */}
      <div className="flex justify-between items-center px-6 flex-shrink-0">
        <h1 className="text-2xl font-bold text-gray-800 tracking-tight flex items-center gap-2">
          <Settings2 className="w-6 h-6 text-blue-600" />
          Custom Reports
        </h1>
        <div className="flex gap-3">
          <Button
            onClick={() => setIsAiDrawerOpen(true)}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white border-none shadow-sm px-4 h-10 rounded-lg transition-all hover:scale-[1.02]"
          >
            <Bot className="w-4 h-4 text-white" />
            <span className="font-semibold text-sm">Ask AI Analyst</span>
          </Button>
          <Button
            onClick={() => navigate('/admin/node_reports')}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white border-none shadow-sm px-4 h-10 rounded-lg transition-all"
          >
            <ArrowLeftRight className="w-4 h-4 text-white" />
            <span className="font-medium text-sm">Visual Node Builder</span>
          </Button>
          <Button
            onClick={handleDownloadExcel}
            className="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white border-none shadow-sm px-4 h-10 rounded-lg transition-all"
            disabled={reportData.length === 0}
          >
            <Download className="w-4 h-4 text-white" />
            <span className="font-medium text-sm">Excel</span>
          </Button>
        </div>
      </div>

      {/* Templates Bar */}
      {templates.length > 0 && (
        <div className="bg-white p-4 rounded-2xl border border-gray-100 shadow-sm flex flex-col gap-2 flex-shrink-0">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2">
              <Settings2 className="w-3.5 h-3.5 text-blue-500" /> Saved Report Queries
            </span>
          </div>
          <div className="flex flex-wrap gap-2 max-h-24 overflow-y-auto custom-scrollbar">
            {templates.map((tpl) => (
              <div
                key={tpl.id}
                onClick={() => handleLoadTemplate(tpl)}
                className="flex items-center gap-2 bg-blue-50/50 hover:bg-blue-100/60 border border-blue-100/60 rounded-xl px-3 py-1.5 cursor-pointer transition-all hover:scale-[1.02] shadow-sm select-none"
              >
                <span className="text-xs font-semibold text-blue-700">{tpl.name}</span>
                <span className="text-[10px] text-blue-400 bg-blue-100/50 px-1.5 py-0.5 rounded font-bold uppercase">
                  {tpl.module}
                </span>
                <button
                  onClick={(e) => handleDeleteTemplate(tpl.id, e)}
                  className="text-blue-400 hover:text-red-500 transition-colors p-0.5"
                  title="Delete template"
                >
                  <Trash2 className="w-3 h-3" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 flex-grow overflow-hidden">
        {/* Controls Sidebar */}
        <div className="lg:col-span-4 xl:col-span-3 h-full overflow-y-auto custom-scrollbar pr-1">
          <Card className="border-none shadow-sm rounded-2xl overflow-hidden bg-white">
            <CardContent className="p-6 space-y-6">
              {/* Advanced Mode Toggle */}
              <div className="flex items-center justify-between p-3.5 bg-indigo-50/40 border border-indigo-100 rounded-xl">
                <span className="text-xs font-bold text-indigo-900 uppercase tracking-wider flex items-center gap-1.5">
                  <ArrowLeftRight className="w-3.5 h-3.5 text-indigo-650" /> Advanced Explorer Mode
                </span>
                <Switch
                  checked={isAdvancedMode}
                  onChange={(checked) => {
                    setIsAdvancedMode(checked);
                    setFilters([]);
                    setReportData([]);
                    setIsGrouping(false);
                    if (checked) {
                      setAdvBaseTable("payment_details");
                      setAdvJoinedTables([]);
                      setAdvSelectedColumns(["payment_details.id", "payment_details.slip_id", "payment_details.amount"]);
                      setGroupByField("payment_details.id");
                      setAggField("payment_details.amount");
                    } else {
                      setModule("payments");
                      setSelectedRelations([]);
                      if (MODULE_CONFIG["payments"]) {
                        setColumns(MODULE_CONFIG["payments"].fields.map((f: any) => f.value));
                        setOrderBy(MODULE_CONFIG["payments"].fields[0].value);
                      }
                    }
                  }}
                  size="small"
                />
              </div>

              {isAdvancedMode ? (
                <div className="space-y-4">
                  {/* Advanced Primary Table select */}
                  <div className="space-y-2">
                    <label className="text-[11px] font-bold text-gray-405 uppercase tracking-widest block">
                      Primary Table
                    </label>
                    <Select
                      value={advBaseTable}
                      onChange={(v) => {
                        setAdvBaseTable(v);
                        setAdvSelectedColumns(
                          TABLE_NODES_CONFIG[v]?.fields.slice(0, 3).map(f => `${v}.${f.name}`) || []
                        );
                        setFilters([]);
                        setReportData([]);
                      }}
                      className="w-full h-11"
                    >
                      {Object.keys(TABLE_NODES_CONFIG).map(key => (
                        <Option key={key} value={key}>
                          {TABLE_NODES_CONFIG[key].label} ({key})
                        </Option>
                      ))}
                    </Select>
                  </div>

                  {/* Advanced Join Tables select */}
                  <div className="space-y-2">
                    <label className="text-[11px] font-bold text-gray-405 uppercase tracking-widest block">
                      Join Additional Tables
                    </label>
                    <Select
                      mode="multiple"
                      placeholder="Select tables to join"
                      value={advJoinedTables}
                      onChange={(v) => {
                        setAdvJoinedTables(v);
                        setReportData([]);
                      }}
                      className="w-full"
                      maxTagCount="responsive"
                    >
                      {Object.keys(TABLE_NODES_CONFIG)
                        .filter(key => key !== advBaseTable)
                        .map(key => (
                          <Option key={key} value={key}>
                            {TABLE_NODES_CONFIG[key].label} ({key})
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              ) : (
                <div className="space-y-4">
                  {/* Module Selection */}
                  <div className="space-y-2">
                    <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2">
                      <LayoutGrid className="w-3 h-3" /> Report Source
                    </label>
                    <Select
                      value={module}
                      onChange={(v) => {
                        setModule(v);
                        setSelectedRelations([]);
                        setFilters([]);
                        setReportData([]);
                        setIsGrouping(false);
                        if (MODULE_CONFIG[v]) {
                          setColumns(MODULE_CONFIG[v].fields.map((f: any) => f.value));
                          setOrderBy(MODULE_CONFIG[v].fields[0].value);
                          setGroupByField(MODULE_CONFIG[v].fields[0].value);
                          setAggField(MODULE_CONFIG[v].fields[0].value);
                        }
                      }}
                      className="w-full h-11"
                    >
                      {Object.keys(MODULE_CONFIG).map((key) => (
                        <Option key={key} value={key}>
                          {MODULE_CONFIG[key].label}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  {/* Linked Tables Selector */}
                  {MODULE_CONFIG[module]?.relations && (
                    <div className="space-y-2 p-4 bg-gray-50/60 rounded-xl border border-gray-100">
                      <label className="text-[11px] font-bold text-gray-700 uppercase tracking-wider flex items-center gap-2">
                        <Plus className="w-3.5 h-3.5 text-blue-500" /> Link Related Tables
                      </label>
                      <div className="flex flex-col gap-2 pt-2 border-t border-gray-100">
                        {Object.keys(MODULE_CONFIG[module].relations).map((relKey) => {
                          const rel = MODULE_CONFIG[module].relations[relKey];
                          return (
                            <div key={relKey} className="flex items-center justify-between">
                              <span className="text-xs font-semibold text-gray-600">{rel.label}</span>
                              <Switch
                                checked={selectedRelations.includes(relKey)}
                                onChange={(checked) => {
                                  let updated;
                                  if (checked) {
                                    updated = [...selectedRelations, relKey];
                                  } else {
                                    updated = selectedRelations.filter((r) => r !== relKey);
                                    // Clean up columns from disabled relation
                                    const relFields = rel.fields.map((f: any) => f.value);
                                    setColumns(columns.filter((c) => !relFields.includes(c)));
                                    // Clean up filters from disabled relation
                                    setFilters(filters.filter((f) => !relFields.includes(f.field)));
                                  }
                                  setSelectedRelations(updated);
                                }}
                                size="small"
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Aggregation & Grouping Panel */}
              <div className="p-4 bg-gray-50/60 rounded-xl border border-gray-100 space-y-4">
                <div className="flex items-center justify-between">
                  <label className="text-xs font-bold text-gray-700 flex items-center gap-2">
                    <Settings2 className="w-3.5 h-3.5 text-blue-500" /> Group & Aggregate
                  </label>
                  <Switch
                    checked={isGrouping}
                    onChange={(checked) => {
                      setIsGrouping(checked);
                      if (checked) {
                        setOrderBy(groupByField);
                      } else {
                        setOrderBy(currentModuleFields[0]?.value || "");
                      }
                    }}
                    size="small"
                  />
                </div>

                {isGrouping && (
                  <div className="space-y-3 pt-2 border-t border-gray-100 animate-fadeIn">
                    <div className="space-y-1">
                      <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                        Group By Field
                      </span>
                      <Select
                        value={groupByField}
                        onChange={(v) => {
                          setGroupByField(v);
                          setOrderBy(v);
                        }}
                        className="w-full"
                        size="small"
                      >
                        {isAdvancedMode ? (
                          getAdvancedFilterableFields().map(f => (
                            <Option key={f.value} value={f.value}>
                              {f.label}
                            </Option>
                          ))
                        ) : (
                          currentModuleFields.map((f: any) => (
                            <Option key={f.value} value={f.value}>
                              {f.table ? `[${f.table}] ` : ""}{f.label}
                            </Option>
                          ))
                        )}
                      </Select>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <div className="space-y-1">
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                          Calculation
                        </span>
                        <Select
                          value={aggFunc}
                          onChange={setAggFunc}
                          className="w-full"
                          size="small"
                        >
                          {AGG_FUNCTIONS.map((func) => (
                            <Option key={func.value} value={func.value}>
                              {func.value}
                            </Option>
                          ))}
                        </Select>
                      </div>

                      {aggFunc !== "COUNT" && (
                        <div className="space-y-1">
                          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                            Metric Field
                          </span>
                          <Select
                            value={aggField}
                            onChange={setAggField}
                            className="w-full"
                            size="small"
                          >
                            {isAdvancedMode ? (
                              getAdvancedFilterableFields()
                                .map(f => (
                                  <Option key={f.value} value={f.value}>
                                    {f.label}
                                  </Option>
                                ))
                            ) : (
                              currentModuleFields
                                .filter((f: any) => f.type === "number")
                                .map((f: any) => (
                                  <Option key={f.value} value={f.value}>
                                    {f.table ? `[${f.table}] ` : ""}{f.label}
                                  </Option>
                                ))
                            )}
                          </Select>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Column Selection (Only active when not grouping) */}
              {!isGrouping && (
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2">
                      <ChevronDown className="w-3 h-3" /> Visible Columns
                    </label>
                    <button
                      type="button"
                      onClick={() => {
                        const allCols = isAdvancedMode
                          ? getAdvancedFilterableFields().map(f => f.value)
                          : currentModuleFields.map((f: any) => f.value);
                        const visibleCols = getVisibleColumns();
                        if (visibleCols.length === allCols.length) {
                          setVisibleColumns([]);
                        } else {
                          setVisibleColumns(allCols);
                        }
                      }}
                      className="text-[10px] text-blue-600 hover:text-blue-700 font-semibold transition-colors focus:outline-none"
                    >
                      {getVisibleColumns().length === (isAdvancedMode ? getAdvancedFilterableFields().length : currentModuleFields.length)
                        ? "Deselect All"
                        : "Select All"}
                    </button>
                  </div>
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Select columns"
                    value={getVisibleColumns()}
                    onChange={setVisibleColumns}
                    className="w-full"
                    maxTagCount="responsive"
                  >
                    {isAdvancedMode ? (
                      getAdvancedFilterableFields().map(f => (
                        <Option key={f.value} value={f.value}>
                          {f.label}
                        </Option>
                      ))
                    ) : (
                      currentModuleFields.map((f: any) => (
                        <Option key={f.value} value={f.value}>
                          {f.table ? `[${f.table}] ` : ""}{f.label}
                        </Option>
                      ))
                    )}
                  </Select>
                </div>
              )}

              {/* Filters Section */}
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-2">
                    <Filter className="w-3 h-3" /> Applied Filters
                  </label>
                  <Button
                    onClick={addFilter}
                    className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white border-none shadow-sm px-4 h-10 rounded-lg transition-all"
                  >
                    <Plus className="w-3 h-3 mr-1" /> Add Filter
                  </Button>
                </div>

                <div className="space-y-3">
                  {filters.length === 0 && (
                    <div className="text-center py-8 bg-gray-50/50 border-2 border-dashed border-gray-100 rounded-xl">
                      <p className="text-xs text-gray-400 font-medium italic">
                        No filters active
                      </p>
                    </div>
                  )}
                  {filters.map((filter, index) => {
                    const fields = isAdvancedMode ? getAdvancedFilterableFields() : currentModuleFields;
                    const fieldConfig = fields.find(
                      (f: any) => f.value === filter.field,
                    );
                    return (
                      <div
                        key={index}
                        className="p-4 bg-gray-50/80 rounded-xl border border-gray-100 relative group transition-all hover:bg-white hover:shadow-md hover:shadow-gray-100"
                      >
                        <button
                          onClick={() => removeFilter(index)}
                          className="absolute -top-2 -right-2 bg-white shadow-md border border-gray-100 rounded-full p-1.5 text-gray-400 hover:text-red-500 transition-all opacity-0 group-hover:opacity-100 hover:scale-110 z-10"
                        >
                          <Trash2 className="w-3 h-3" />
                        </button>
                        <div className="space-y-2.5">
                          <Select
                            value={filter.field}
                            onChange={(v) => {
                              updateFilter(index, "field", v);
                              const newF = fields.find(
                                (f: any) => f.value === v,
                              );
                              if (
                                newF?.type === "date" ||
                                newF?.type === "datetime"
                              ) {
                                updateFilter(index, "operator", "between");
                              }
                            }}
                            className="w-full"
                            size="small"
                          >
                            {fields.map((f: any) => (
                              <Option key={f.value} value={f.value}>
                                {f.label}
                              </Option>
                            ))}
                          </Select>
                          <div className="grid grid-cols-2 gap-2">
                            <Select
                              value={filter.operator}
                              onChange={(v) =>
                                updateFilter(index, "operator", v)
                              }
                              className="w-full"
                              size="small"
                            >
                              {OPERATORS.map((op) => (
                                <Option key={op.value} value={op.value}>
                                  {op.label}
                                </Option>
                              ))}
                            </Select>
                            {filter.operator === "between" ? (
                              fieldConfig?.type === "date" ||
                              fieldConfig?.type === "datetime" ? (
                                <RangePicker
                                  size="small"
                                  className="w-full"
                                  onChange={(dates) =>
                                    updateFilter(index, "value", dates)
                                  }
                                  value={filter.value}
                                />
                              ) : (
                                <div className="flex gap-1 items-center w-full">
                                  <Input
                                    placeholder="Min"
                                    value={
                                      Array.isArray(filter.value)
                                        ? filter.value[0]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      const currentVal = Array.isArray(
                                        filter.value,
                                      )
                                        ? [...filter.value]
                                        : ["", ""];
                                      currentVal[0] = e.target.value;
                                      updateFilter(index, "value", currentVal);
                                    }}
                                    className="h-8 text-xs rounded-lg w-[45%]"
                                  />
                                  <span className="text-gray-400 text-[10px]">
                                    -
                                  </span>
                                  <Input
                                    placeholder="Max"
                                    value={
                                      Array.isArray(filter.value)
                                        ? filter.value[1]
                                        : ""
                                    }
                                    onChange={(e) => {
                                      const currentVal = Array.isArray(
                                        filter.value,
                                      )
                                        ? [...filter.value]
                                        : ["", ""];
                                      currentVal[1] = e.target.value;
                                      updateFilter(index, "value", currentVal);
                                    }}
                                    className="h-8 text-xs rounded-lg w-[45%]"
                                  />
                                </div>
                              )
                            ) : (
                              <Input
                                placeholder="Value..."
                                value={
                                  Array.isArray(filter.value)
                                    ? ""
                                    : filter.value
                                }
                                onChange={(e) =>
                                  updateFilter(index, "value", e.target.value)
                                }
                                className="h-8 text-xs rounded-lg"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Advanced Settings */}
              <div className="pt-4 border-t border-gray-100 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5">
                      <ArrowUpDown className="w-3 h-3" /> Sort By
                    </label>
                    <Select
                      value={orderBy}
                      onChange={setOrderBy}
                      className="w-full h-10"
                      size="small"
                    >
                      {isGrouping ? (
                        <>
                          <Option value={groupByField}>
                            {currentModuleFields.find((f: any) => f.value === groupByField)?.label || groupByField}
                          </Option>
                          <Option value="aggregate_value">Metric Value</Option>
                        </>
                      ) : (
                        currentModuleFields.map((f: any) => (
                          <Option key={f.value} value={f.value}>
                            {f.label}
                          </Option>
                        ))
                      )}
                    </Select>
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5">
                      Direction
                    </label>
                    <Select
                      value={orderDir}
                      onChange={setOrderDir}
                      className="w-full h-10"
                      size="small"
                    >
                      <Option value="ASC">Ascending</Option>
                      <Option value="DESC">Descending</Option>
                    </Select>
                  </div>
                </div>

                <div className="space-y-1.5">
                  <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1.5">
                    <ListOrdered className="w-3 h-3" /> Row Limit
                  </label>
                  <InputNumber
                    min={1}
                    max={5000}
                    value={limit}
                    onChange={(v) => setLimit(v || 1000)}
                    className="w-full h-10 rounded-lg flex items-center"
                  />
                </div>
              </div>

              {/* Generate and Save templates buttons */}
              <div className="flex gap-2 w-full pt-2">
                <Button
                  onClick={runReport}
                  disabled={loading}
                  className="flex-grow bg-blue-600 hover:bg-blue-700 text-white h-12 shadow-lg shadow-blue-100 rounded-xl transition-all hover:-translate-y-0.5 active:translate-y-0"
                >
                  {loading ? (
                    <Spin size="small" className="brightness-0 invert" />
                  ) : (
                    <div className="flex items-center gap-2 justify-center">
                      <Search className="w-4 h-4" />
                      <span className="font-bold">Generate Insights</span>
                    </div>
                  )}
                </Button>
                <Button
                  onClick={() => setIsSaveModalOpen(true)}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-900 border-none h-12 w-12 rounded-xl transition-all flex items-center justify-center flex-shrink-0"
                  title="Save current layout as template"
                >
                  <Plus className="w-5 h-5" />
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Results Area */}
        <div className="lg:col-span-8 xl:col-span-9 h-full overflow-hidden">
          <div className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100 flex flex-col h-full">
            <div className="p-5 border-b border-gray-100 bg-white/80 backdrop-blur-md flex justify-between items-center sticky top-0 z-20">
              <div className="flex items-center gap-3">
                <Tag
                  color="blue"
                  className="rounded-lg px-3 py-0.5 font-bold border-none bg-blue-50 text-blue-600"
                >
                  {reportData.length} Records Found
                </Tag>
                {loading && (
                  <div className="flex items-center gap-2 text-blue-600">
                    <Spin size="small" />
                    <span className="text-xs font-bold animate-pulse">
                      Computing...
                    </span>
                  </div>
                )}
              </div>
              <div className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
                Showing results for:{" "}
                <span className="text-blue-600">
                  {isAdvancedMode ? "Advanced Explorer Join Query" : (MODULE_CONFIG[module]?.label || module)}
                </span>
              </div>
            </div>

            <div className="flex-grow overflow-auto max-h-[calc(100vh-320px)]">
              {reportData.length > 0 ? (
                <Table className="min-w-max text-sm">
                  <TableHeader className="bg-gray-50/50">
                    <TableRow className="hover:bg-transparent">
                      {isGrouping ? (
                        <>
                          <TableHead className="py-4 px-6 font-bold text-gray-600 border-b border-gray-100 whitespace-nowrap">
                            {isAdvancedMode 
                              ? groupByField 
                              : (currentModuleFields.find((f: any) => f.value === groupByField)?.label || groupByField)}
                          </TableHead>
                          <TableHead className="py-4 px-6 font-bold text-gray-600 border-b border-gray-100 whitespace-nowrap">
                            {aggFunc === "COUNT" 
                              ? "Record Count" 
                              : `${aggFunc} of ${isAdvancedMode ? aggField : (currentModuleFields.find((f: any) => f.value === aggField)?.label || aggField)}`}
                          </TableHead>
                        </>
                      ) : (
                        getVisibleColumns().map((col) => (
                          <TableHead
                            key={col}
                            className="py-4 px-6 font-bold text-gray-600 border-b border-gray-100 whitespace-nowrap"
                          >
                            {isAdvancedMode 
                              ? col 
                              : (currentModuleFields.find((f: any) => f.value === col)?.label || col)}
                          </TableHead>
                        ))
                      )}
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {reportData.map((row, index) => (
                      <TableRow
                        key={index}
                        className="border-b border-gray-50 last:border-0 hover:bg-blue-50/20 transition-all group"
                      >
                        {isGrouping ? (
                          <>
                            <TableCell className="px-6 py-4 text-gray-600 group-hover:text-gray-900 transition-colors">
                              {row[groupByField] || row[groupByField.replace('.', '$')] || (
                                <span className="text-gray-300 italic font-light">
                                  --
                                </span>
                              )}
                            </TableCell>
                            <TableCell className="px-6 py-4 text-gray-600 group-hover:text-gray-900 transition-colors">
                              {isCurrencyCell("aggregate_value") ? (
                                <span className="font-bold text-gray-900 bg-emerald-50 text-emerald-700 px-2 py-1 rounded-md text-xs">
                                  {formatCurrency(row.aggregate_value)}
                                </span>
                              ) : (
                                row.aggregate_value || 0
                              )}
                            </TableCell>
                          </>
                        ) : (
                          getVisibleColumns().map((col) => (
                            <TableCell
                              key={col}
                              className="px-6 py-4 text-gray-600 group-hover:text-gray-900 transition-colors"
                            >
                              {isCurrencyCell(col) ? (
                                <span className="font-bold text-gray-900 bg-emerald-50 text-emerald-700 px-2 py-1 rounded-md text-xs">
                                  {formatCurrency(row[col] ?? row[col.replace('.', '$')])}
                                </span>
                              ) : (
                                (row[col] ?? row[col.replace('.', '$')]) || (
                                  <span className="text-gray-300 italic font-light">
                                    --
                                  </span>
                                )
                              )}
                            </TableCell>
                          ))
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                !loading && (
                  <div className="flex flex-col items-center justify-center py-48 text-gray-400">
                    <div className="bg-gray-50 p-6 rounded-full mb-6">
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                          <div className="space-y-1">
                            <p className="text-gray-500 font-bold">
                              No Data Generated
                            </p>
                            <p className="text-xs text-gray-400 max-w-[200px] mx-auto font-medium">
                              Configure filters and columns in the sidebar to
                              build your report
                            </p>
                          </div>
                        }
                      />
                    </div>
                  </div>
                )
              )}
            </div>

            {reportData.length > 0 && (
              <div className="p-4 border-t border-gray-50 bg-gray-50/30 flex justify-end">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest italic">
                  Generated on {new Date().toLocaleString()}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Save Template Modal */}
      <Modal
        title={
          <div className="flex items-center gap-2 border-b border-gray-100 pb-3">
            <Settings2 className="w-5 h-5 text-blue-500" />
            <span className="font-bold text-gray-800 text-lg">
              Save Query Template
            </span>
          </div>
        }
        open={isSaveModalOpen}
        onOk={handleSaveTemplate}
        onCancel={() => {
          setIsSaveModalOpen(false);
          setTemplateName("");
        }}
        okText="Save Template"
        cancelText="Cancel"
        centered
      >
        <div className="py-4 space-y-4">
          <p className="text-sm text-gray-500 font-medium">
            Save your currently configured columns, filters, and ordering
            settings as a reusable report query template.
          </p>
          <div className="space-y-1.5">
            <label className="text-xs font-bold text-gray-400 uppercase tracking-wider">
              Template Name
            </label>
            <Input
              placeholder="e.g. Monthly Remittances by Bank"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              className="h-10 rounded-lg text-sm"
              autoFocus
            />
          </div>
        </div>
      </Modal>

      {/* AI Analyst Drawer */}
      <Drawer
        title={
          <div className="flex items-center gap-2 border-b border-gray-100 pb-3">
            <Bot className="w-5 h-5 text-blue-600" />
            <span className="font-bold text-gray-800 text-lg">AI Reports Analyst</span>
          </div>
        }
        open={isAiDrawerOpen}
        onClose={() => {
          setIsAiDrawerOpen(false);
          setAiPrompt("");
          setAiExplanation("");
          setAiSql("");
        }}
        width={500}
      >
        <div className="py-2 flex flex-col gap-4">
          <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
            <h4 className="text-xs font-bold text-blue-800 uppercase tracking-wider mb-1">How it works:</h4>
            <p className="text-xs text-gray-600 leading-relaxed font-medium">
              Write down the exact report structure you want to build in plain English (e.g. <i>"Find total payments by each customer in June 2026"</i>).
              The AI assistant will translate your prompt into an optimized SQL SELECT query, run it, and render the output records directly in the reports table.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <TextArea
              placeholder="Type your reporting request..."
              value={aiPrompt}
              onChange={(e) => setAiPrompt(e.target.value)}
              disabled={aiLoading}
              rows={10}
              className="rounded-lg text-xs border-slate-200 resize-none"
            />
            <Button
              onClick={() => handleAiSearch(aiPrompt)}
              disabled={aiLoading || !aiPrompt.trim()}
              className="bg-blue-600 hover:bg-blue-700 text-white border-none h-10 px-4 rounded-lg flex items-center gap-1.5 font-bold"
            >
              {aiLoading ? <Spin size="small" className="brightness-0 invert" /> : <Send className="w-3.5 h-3.5" />}
              Generate Custom Report
            </Button>
          </div>

          {aiLoading && (
            <div className="py-12 flex flex-col items-center justify-center gap-3">
              <Spin />
              <span className="text-[11px] text-gray-400 font-medium animate-pulse">Running SQL queries on the server...</span>
            </div>
          )}

          {aiExplanation && (
            <div className="bg-gray-50 border border-gray-150 rounded-xl p-4 flex flex-col gap-2">
              <div className="flex items-center gap-1.5 text-xs font-bold text-gray-700">
                <Sparkles className="w-3.5 h-3.5 text-blue-500" /> Explanation
              </div>
              <p className="text-xs text-gray-600 leading-relaxed font-medium">{aiExplanation}</p>
            </div>
          )}

          {aiSql && (
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-4 flex flex-col gap-2 text-gray-300">
              <div className="flex items-center gap-1.5 text-xs font-bold text-gray-400">
                <Terminal className="w-3.5 h-3.5 text-emerald-400" /> Executed SQL Query
              </div>
              <pre className="text-[10px] font-mono bg-black/60 p-2.5 rounded border border-gray-850 overflow-x-auto text-emerald-400">{aiSql}</pre>
            </div>
          )}
        </div>
      </Drawer>
    </div>
  );
};
